import { useCallback, useEffect, useState } from 'react';
import { fetchDaData } from '../helpers/actions';
import { useDebounce } from '../../../shared/hooks/useDebounce';

export interface EmployersForSelect {
    avatar: string;
    display_name: string;
    email: string;
    guid: string;
    position: string;
    user_id: number;
}

export const useSecondStep = (onLoaderChange: (value: boolean) => void) => {
    const [employersList, setEmployersList] = useState<EmployersForSelect[]>([]);

    const debouncedFetchData = useDebounce((name: string, value: string) => {
        fetchDaData(value)
            .then((data) => {
                setEmployersList(data);
            })
            .finally(() => {
                onLoaderChange(false);
            });
    }, 500);

    const onEmployersListSet = useCallback((value: string) => {
        debouncedFetchData('', value);
    }, []);

    useEffect(() => {
        fetchDaData()
            .then((data) => {
                setEmployersList(data);
            })
            .finally(() => {
                onLoaderChange(false);
            });
    }, []);
    return { employersList, onEmployersListSet };
};
